export const AUTH_REQUEST = 'AUTH/REQUEST';
export const AUTH_LOGOUT = 'AUTH/LOGOUT';
export const AUTH_LOGOUT_SUCCESS = 'AUTH/LOGOUT_SUCCESS';
export const AUTH_SUCCESS = 'AUTH/SUCCESS';
export const AUTH_FAILURE = 'AUTH/FAILURE';
export const AUTH_FAILURE_UNAUTHORIZED = 'AUTH/FAILURE_UNAUTHORIZED';

const initialState = {
  token: localStorage.getItem('token'),
  error: null,
};

export const authorize = (login, password) => ({
  type: AUTH_REQUEST,
  payload: { login, password },
});

export const logout = () => ({
  type: AUTH_LOGOUT,
  payload: {},
});

export const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AUTH_SUCCESS: {
      return { ...state, error: false, token: payload };
    }
    case AUTH_LOGOUT_SUCCESS: {
      return { ...state, token: '' };
    }
    case AUTH_FAILURE:
    case AUTH_FAILURE_UNAUTHORIZED: {
      return { ...state, error: payload, token: '' };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.reducer.js